export enum ShippingMethodEnum {
  WAREHOUSE = 'Warehouse',
  DOORS = 'Doors',
  PICKUP = 'Pickup',

  // custom transforms
  LAST_ORDERED = 'LastOrdered',
}
